import type { InvoiceDate, InvoiceFilter, SortingItem } from '@vy/types';
import { fromNullToUndefined } from '@vy/utils';
import { useTablePagination } from '../../../hooks/use-table-pagination';
import { useTableSorting } from '../../../hooks/use-table-sorting';
import { useFiltersParam } from './use-filters-param';
import { useDatesParam } from './use-months-param';
import { useQueryInputParams } from './use-query-input-param';

type UseInvoicesPageParamsNew = {
  issuedDates?: InvoiceDate[];
  search?: string;
  page?: number;
  pageSize?: number;
  filters?: InvoiceFilter[];
  currentSortModel?: SortingItem;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

export function useInvoicesPageParamsNew(): UseInvoicesPageParamsNew {
  const [dates] = useDatesParam();
  const [search] = useQueryInputParams();
  const { page, pageSize, onPageChange, onPageSizeChange } = useTablePagination();
  const [filters] = useFiltersParam();
  const { currentSortModel } = useTableSorting();

  return {
    issuedDates: fromNullToUndefined(dates),
    search: fromNullToUndefined(search),
    page: fromNullToUndefined(page),
    pageSize: fromNullToUndefined(pageSize),
    filters: fromNullToUndefined(filters),
    currentSortModel: fromNullToUndefined(currentSortModel),
    onPageChange,
    onPageSizeChange,
  };
}
